import React from 'react';
import { Link } from '@chakra-ui/react';

export default function NavSectionLink({
	href,
	label,
	accentColor = 'cyan.400',
	isActive = false,
	onNavigate,
}) {
	return (
		<Link
			href={href}
			position='relative'
			color={isActive ? accentColor : 'whiteAlpha.900'}
			fontWeight={isActive ? 'semibold' : 'medium'}
			fontSize='sm'
			_hover={{ color: accentColor }}
			transition='color 0.25s'
			onClick={(e) => {
				if (onNavigate) {
					e.preventDefault();
					onNavigate(href);
				}
			}}
			_after={{
				content: '""',
				position: 'absolute',
				bottom: '-6px',
				left: 0,
				right: 0,
				h: '2px',
				bg: accentColor,
				borderRadius: 'full',
				transform: isActive ? 'scaleX(1)' : 'scaleX(0)',
				transition: 'transform 0.3s cubic-bezier(0.22, 1, 0.36, 1)',
				boxShadow: isActive ? '0 0 8px rgba(34,211,238,0.6)' : 'none',
			}}>
			{label}
		</Link>
	);
}
